import { compareGreater } from '@dte/otw-utils-core/src/objects/compare/compareGreater';
import { CompareOrder } from '@dte/otw-utils-core/src/objects/compare/CompareOrder';

import type { DateRepresentation } from '../DateRepresentation';
import { safeParseDate } from '../parse/date';

export function compareLatest(
	a: DateRepresentation,
	b: DateRepresentation,
	// For sorting, put undefined at the start of the list by default
	handleUndefined: CompareOrder = CompareOrder.Before,
): CompareOrder {
	const timeA = safeParseDate(a)?.getTime();
	const timeB = safeParseDate(b)?.getTime();

	return compareGreater(timeA, timeB, handleUndefined);
}
